import { t } from "@/i18n-js/instance";
import { Collapsible } from "@circle-react-uikit/Collapsible";
import { Form } from "@circle-react-uikit/Form";
import { generateFormItemName } from "./Styles";

export const Background = () => (
  <Collapsible title={t("builder_ui.prop_type.styles.background")} defaultOpen>
    <div className="px-6 py-5">
      <Form.Item
        name={generateFormItemName("backgroundColor")}
        label={t(
          "settings.emails.visual_builder.prop_type.styles.background_color",
        )}
        hideDescription
        hideBorder
        className="!flex !w-full !items-center !justify-between !p-0"
      >
        <Form.ColorPickerV2
          name={generateFormItemName("backgroundColor")}
          shouldShowAlpha={false}
        />
      </Form.Item>
    </div>
  </Collapsible>
);
